import { configureStore } from "@reduxjs/toolkit";

import authReducer from './Auth'
import siteReducer from './Site'
import cartReducer from './Cart'
export default configureStore({
  reducer: {auth:authReducer,site:siteReducer,cart:cartReducer}
})